require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./shadow.js.shim.module$react_dom.js");

require("./com.wsscode.blog.benchmark.js");

require("./com.wsscode.blog.components.charts.js");

require("./com.wsscode.js_interop.js_proxy.js");

require("./goog.object.object.js");

require("./helix.core.js");

require("./helix.dom.js");

require("./helix.hooks.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.blog.alternative_to_clj_js.js");
goog.provide('com.wsscode.blog.alternative_to_clj_js');

com.wsscode.blog.alternative_to_clj_js.gen_map_sized = function com$wsscode$blog$alternative_to_clj_js$gen_map_sized(size) {
  return cljs.core.zipmap(cljs.core.map.cljs$core$IFn$_invoke$arity$2(function (p1__24403_SHARP_) {
    return ["entry-", cljs.core.str.cljs$core$IFn$_invoke$arity$1(p1__24403_SHARP_)].join('');
  }, cljs.core.range.cljs$core$IFn$_invoke$arity$1(size)), cljs.core.repeatedly.cljs$core$IFn$_invoke$arity$1(function () {
    return cljs.core.rand_int(size);
  }));
};

com.wsscode.blog.alternative_to_clj_js.bench_reads = function com$wsscode$blog$alternative_to_clj_js$bench_reads(p__24404) {
  var map__24405 = p__24404;
  var map__24405__$1 = (!(map__24405 == null) ? map__24405.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24405.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24405) : map__24405;
  var data = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24405__$1, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "data", "com.wsscode.blog.alternative-to-clj-js/data", -1763746451));
  var f = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24405__$1, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090));
  var reads_range = cljs.core.range.cljs$core$IFn$_invoke$arity$1(31);
  var times = 100;
  var keys = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(cljs.core.keys(data), null);
  var keys_count = cljs.core.count(keys);
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map_indexed.cljs$core$IFn$_invoke$arity$1(function (n, reads) {
    return new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "x", "x", 2099068185), n, new cljs.core.Keyword(null, "y", "y", -1757859776), com.wsscode.blog.benchmark.bench(times, function () {
      var x = f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(data) : f.call(null, data);
      var n__4613__auto__ = reads;
      var k = 0;

      while (true) {
        if (k < n__4613__auto__) {
          goog.object.get(x, keys[cljs.core.mod(k, keys_count)]);
          var G__24516 = k + 1;
          k = G__24516;
          continue;
        } else {
          return null;
        }

        break;
      }
    })], null);
  }), reads_range);
};

com.wsscode.blog.alternative_to_clj_js.ReadsCompareProgressive = function () {
  var G__24413 = function com$wsscode$blog$alternative_to_clj_js$ReadsCompareProgressive_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__24414 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var vec__24417 = helix.hooks.use_state(1);
    var entries = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24417, 0, null);
    var set_entries = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24417, 1, null);
    var vec__24420 = helix.hooks.use_state(null);
    var hash = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24420, 0, null);
    var set_hash = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24420, 1, null);

    var data = function () {
      var G__24423 = function G__24423() {
        return com.wsscode.blog.alternative_to_clj_js.gen_map_sized(entries);
      };

      var G__24424 = [entries, hash];
      return helix.hooks.raw_use_memo.cljs$core$IFn$_invoke$arity$2 ? helix.hooks.raw_use_memo.cljs$core$IFn$_invoke$arity$2(G__24423, G__24424) : helix.hooks.raw_use_memo.call(null, G__24423, G__24424);
    }();

    return helix.core.get_react().createElement("div", function () {
      var obj24426 = {
        "style": function () {
          var obj24428 = {
            "height": helix.impl.props.__GT_js("300px"),
            "display": helix.impl.props.__GT_js("flex")
          };
          return obj24428;
        }()
      };
      return obj24426;
    }(), com.wsscode.blog.components.charts.line_chart(new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "data", "data", -232669377), new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "id", "id", -1388402092), "clj->js", new cljs.core.Keyword(null, "data", "data", -232669377), com.wsscode.blog.alternative_to_clj_js.bench_reads(new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "data", "com.wsscode.blog.alternative-to-clj-js/data", -1763746451), data, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090), cljs.core.clj__GT_js], null))], null), new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "id", "id", -1388402092), "proxy", new cljs.core.Keyword(null, "data", "data", -232669377), com.wsscode.blog.alternative_to_clj_js.bench_reads(new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "data", "com.wsscode.blog.alternative-to-clj-js/data", -1763746451), data, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090), com.wsscode.js_interop.js_proxy.map_proxy], null))], null)], null), new cljs.core.Keyword(null, "margin", "margin", -995903681), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "top", "top", -1856271961), 10, new cljs.core.Keyword(null, "right", "right", -452581833), 30, new cljs.core.Keyword(null, "bottom", "bottom", -1550509018), 50, new cljs.core.Keyword(null, "left", "left", -399115937), 50], null), new cljs.core.Keyword(null, "enableSlices", "enableSlices", -947249609), "x", new cljs.core.Keyword(null, "padding", "padding", 1660304693), 0.3], null)), helix.core.get_react().createElement("div", function () {
      var obj24430 = {
        "style": function () {
          var obj24432 = {
            "alignSelf": helix.impl.props.__GT_js("center")
          };
          return obj24432;
        }()
      };
      return obj24430;
    }(), helix.core.get_react().createElement("div", function () {
      var obj24434 = {
        "style": function () {
          var obj24436 = {
            "textAlign": helix.impl.props.__GT_js("center"),
            "marginBottom": helix.impl.props.__GT_js(10)
          };
          return obj24436;
        }()
      };
      return obj24434;
    }(), helix.core.get_react().createElement("button", function () {
      var obj24438 = {
        "onClick": function onClick() {
          var G__24439 = cljs.core.random_uuid();
          return set_hash.cljs$core$IFn$_invoke$arity$1 ? set_hash.cljs$core$IFn$_invoke$arity$1(G__24439) : set_hash.call(null, G__24439);
        }
      };
      return obj24438;
    }(), "Re-run")), helix.core.get_react().createElement("hr", null), helix.core.get_react().createElement("label", null, "Map Size", helix.core.get_react().createElement("input", function () {
      var obj24441 = {
        "type": "range",
        "value": helix.impl.props.or_undefined(entries),
        "min": 0,
        "max": 15,
        "onChange": function onChange(p1__24407_SHARP_) {
          var G__24442 = parseInt(p1__24407_SHARP_.target.value);
          return set_entries.cljs$core$IFn$_invoke$arity$1 ? set_entries.cljs$core$IFn$_invoke$arity$1(G__24442) : set_entries.call(null, G__24442);
        }
      };
      return obj24441;
    }()), helix.core.get_react().createElement("div", null, entries, " entries"))));
  };

  if (goog.DEBUG === true) {
    var G__24443 = G__24413;
    G__24443.displayName = "com.wsscode.blog.alternative-to-clj-js/ReadsCompareProgressive";
    return G__24443;
  } else {
    return G__24413;
  }
}();

goog.exportSymbol('com.wsscode.blog.alternative_to_clj_js.ReadsCompareProgressive', com.wsscode.blog.alternative_to_clj_js.ReadsCompareProgressive);

com.wsscode.blog.alternative_to_clj_js.bench_spread = function com$wsscode$blog$alternative_to_clj_js$bench_spread(p__24444) {
  var map__24445 = p__24444;
  var map__24445__$1 = (!(map__24445 == null) ? map__24445.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24445.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24445) : map__24445;
  var f = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24445__$1, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090));
  var size_range = cljs.core.range.cljs$core$IFn$_invoke$arity$1(31);
  var times = 100;
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (n) {
    var data = com.wsscode.blog.alternative_to_clj_js.gen_map_sized(n);
    return new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "x", "x", 2099068185), n, new cljs.core.Keyword(null, "y", "y", -1757859776), com.wsscode.blog.benchmark.bench(times, function () {
      var x = f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(data) : f.call(null, data);
      return Object.assign({}, x);
    })], null);
  }), size_range);
};

com.wsscode.blog.alternative_to_clj_js.SpreadObjectBenchmark = function () {
  var G__24450 = function com$wsscode$blog$alternative_to_clj_js$SpreadObjectBenchmark_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__24451 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var vec__24454 = helix.hooks.use_state(null);

    var _ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24454, 0, null);

    var set_hash = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24454, 1, null);
    return helix.core.get_react().createElement("div", function () {
      var obj24458 = {
        "style": function () {
          var obj24460 = {
            "height": helix.impl.props.__GT_js("300px"),
            "display": helix.impl.props.__GT_js("flex")
          };
          return obj24460;
        }()
      };
      return obj24458;
    }(), com.wsscode.blog.components.charts.line_chart(new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "data", "data", -232669377), new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "id", "id", -1388402092), "clj->js", new cljs.core.Keyword(null, "data", "data", -232669377), com.wsscode.blog.alternative_to_clj_js.bench_spread(new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090), cljs.core.clj__GT_js], null))], null), new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "id", "id", -1388402092), "proxy", new cljs.core.Keyword(null, "data", "data", -232669377), com.wsscode.blog.alternative_to_clj_js.bench_spread(new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090), com.wsscode.js_interop.js_proxy.map_proxy], null))], null)], null), new cljs.core.Keyword(null, "margin", "margin", -995903681), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "top", "top", -1856271961), 10, new cljs.core.Keyword(null, "right", "right", -452581833), 30, new cljs.core.Keyword(null, "bottom", "bottom", -1550509018), 50, new cljs.core.Keyword(null, "left", "left", -399115937), 50], null), new cljs.core.Keyword(null, "enableSlices", "enableSlices", -947249609), "x", new cljs.core.Keyword(null, "padding", "padding", 1660304693), 0.3], null)), helix.core.get_react().createElement("div", function () {
      var obj24462 = {
        "style": function () {
          var obj24464 = {
            "alignSelf": helix.impl.props.__GT_js("center")
          };
          return obj24464;
        }()
      };
      return obj24462;
    }(), helix.core.get_react().createElement("div", function () {
      var obj24466 = {
        "style": function () {
          var obj24468 = {
            "textAlign": helix.impl.props.__GT_js("center"),
            "marginBottom": helix.impl.props.__GT_js(10)
          };
          return obj24468;
        }()
      };
      return obj24466;
    }(), helix.core.get_react().createElement("button", function () {
      var obj24470 = {
        "onClick": function onClick() {
          var G__24471 = cljs.core.random_uuid();
          return set_hash.cljs$core$IFn$_invoke$arity$1 ? set_hash.cljs$core$IFn$_invoke$arity$1(G__24471) : set_hash.call(null, G__24471);
        }
      };
      return obj24470;
    }(), "Re-run"))));
  };

  if (goog.DEBUG === true) {
    var G__24472 = G__24450;
    G__24472.displayName = "com.wsscode.blog.alternative-to-clj-js/SpreadObjectBenchmark";
    return G__24472;
  } else {
    return G__24450;
  }
}();

goog.exportSymbol('com.wsscode.blog.alternative_to_clj_js.SpreadObjectBenchmark', com.wsscode.blog.alternative_to_clj_js.SpreadObjectBenchmark);

com.wsscode.blog.alternative_to_clj_js.bench_seq_reads = function com$wsscode$blog$alternative_to_clj_js$bench_seq_reads(p__24473) {
  var map__24474 = p__24473;
  var map__24474__$1 = (!(map__24474 == null) ? map__24474.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24474.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24474) : map__24474;
  var data = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24474__$1, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "data", "com.wsscode.blog.alternative-to-clj-js/data", -1763746451));
  var f = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24474__$1, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090));
  var reads_range = cljs.core.range.cljs$core$IFn$_invoke$arity$1(31);
  var times = 100;
  var keys = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(cljs.core.keys(data), null);
  var keys_count = cljs.core.count(keys);
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map_indexed.cljs$core$IFn$_invoke$arity$1(function (n, reads) {
    return new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "x", "x", 2099068185), n, new cljs.core.Keyword(null, "y", "y", -1757859776), com.wsscode.blog.benchmark.bench(times, function () {
      var x = f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(data) : f.call(null, data);
      return x.forEach(function () {
        var n__4613__auto__ = reads;
        var k = 0;

        while (true) {
          if (k < n__4613__auto__) {
            goog.object.get(x, keys[cljs.core.mod(k, keys_count)]);
            var G__24518 = k + 1;
            k = G__24518;
            continue;
          } else {
            return null;
          }

          break;
        }
      });
    })], null);
  }), reads_range);
};

com.wsscode.blog.alternative_to_clj_js.ReadsCompareSequence = function () {
  var G__24479 = function com$wsscode$blog$alternative_to_clj_js$ReadsCompareSequence_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__24480 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var vec__24483 = helix.hooks.use_state(10);
    var seq_size = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24483, 0, null);
    var set_seq_size = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24483, 1, null);
    var vec__24486 = helix.hooks.use_state(1);
    var entries = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24486, 0, null);
    var set_entries = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24486, 1, null);
    var vec__24489 = helix.hooks.use_state(null);
    var hash = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24489, 0, null);
    var set_hash = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24489, 1, null);

    var data = function () {
      var G__24492 = function G__24492() {
        return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function () {
          return com.wsscode.blog.alternative_to_clj_js.gen_map_sized(entries);
        }), cljs.core.range.cljs$core$IFn$_invoke$arity$1(seq_size));
      };

      var G__24493 = [entries, hash];
      return helix.hooks.raw_use_memo.cljs$core$IFn$_invoke$arity$2 ? helix.hooks.raw_use_memo.cljs$core$IFn$_invoke$arity$2(G__24492, G__24493) : helix.hooks.raw_use_memo.call(null, G__24492, G__24493);
    }();

    return helix.core.get_react().createElement("div", function () {
      var obj24495 = {
        "style": function () {
          var obj24497 = {
            "height": helix.impl.props.__GT_js("300px"),
            "display": helix.impl.props.__GT_js("flex")
          };
          return obj24497;
        }()
      };
      return obj24495;
    }(), com.wsscode.blog.components.charts.line_chart(new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "data", "data", -232669377), new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "id", "id", -1388402092), "clj->js", new cljs.core.Keyword(null, "data", "data", -232669377), com.wsscode.blog.alternative_to_clj_js.bench_reads(new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "data", "com.wsscode.blog.alternative-to-clj-js/data", -1763746451), data, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090), cljs.core.clj__GT_js], null))], null), new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "id", "id", -1388402092), "proxy", new cljs.core.Keyword(null, "data", "data", -232669377), com.wsscode.blog.alternative_to_clj_js.bench_reads(new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "data", "com.wsscode.blog.alternative-to-clj-js/data", -1763746451), data, new cljs.core.Keyword("com.wsscode.blog.alternative-to-clj-js", "f", "com.wsscode.blog.alternative-to-clj-js/f", -2011348090), com.wsscode.js_interop.js_proxy.jsp], null))], null)], null), new cljs.core.Keyword(null, "margin", "margin", -995903681), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "top", "top", -1856271961), 20, new cljs.core.Keyword(null, "right", "right", -452581833), 50, new cljs.core.Keyword(null, "bottom", "bottom", -1550509018), 50, new cljs.core.Keyword(null, "left", "left", -399115937), 50], null), new cljs.core.Keyword(null, "enableSlices", "enableSlices", -947249609), "x", new cljs.core.Keyword(null, "padding", "padding", 1660304693), 0.3], null)), helix.core.get_react().createElement("div", function () {
      var obj24499 = {
        "style": function () {
          var obj24501 = {
            "alignSelf": helix.impl.props.__GT_js("center")
          };
          return obj24501;
        }()
      };
      return obj24499;
    }(), helix.core.get_react().createElement("div", function () {
      var obj24503 = {
        "style": function () {
          var obj24505 = {
            "textAlign": helix.impl.props.__GT_js("center"),
            "marginBottom": helix.impl.props.__GT_js(10)
          };
          return obj24505;
        }()
      };
      return obj24503;
    }(), helix.core.get_react().createElement("button", function () {
      var obj24507 = {
        "onClick": function onClick() {
          var G__24508 = cljs.core.random_uuid();
          return set_hash.cljs$core$IFn$_invoke$arity$1 ? set_hash.cljs$core$IFn$_invoke$arity$1(G__24508) : set_hash.call(null, G__24508);
        }
      };
      return obj24507;
    }(), "Re-run")), helix.core.get_react().createElement("hr", null), helix.core.get_react().createElement("label", null, "Sequence Size", helix.core.get_react().createElement("input", function () {
      var obj24510 = {
        "type": "range",
        "value": helix.impl.props.or_undefined(seq_size),
        "min": 0,
        "max": 100,
        "onChange": function onChange(p1__24476_SHARP_) {
          var G__24511 = parseInt(p1__24476_SHARP_.target.value);
          return set_seq_size.cljs$core$IFn$_invoke$arity$1 ? set_seq_size.cljs$core$IFn$_invoke$arity$1(G__24511) : set_seq_size.call(null, G__24511);
        }
      };
      return obj24510;
    }()), helix.core.get_react().createElement("div", null, seq_size, " items")), helix.core.get_react().createElement("hr", null), helix.core.get_react().createElement("label", null, "Map Size", helix.core.get_react().createElement("input", function () {
      var obj24513 = {
        "type": "range",
        "value": helix.impl.props.or_undefined(entries),
        "min": 0,
        "max": 15,
        "onChange": function onChange(p1__24477_SHARP_) {
          var G__24514 = parseInt(p1__24477_SHARP_.target.value);
          return set_entries.cljs$core$IFn$_invoke$arity$1 ? set_entries.cljs$core$IFn$_invoke$arity$1(G__24514) : set_entries.call(null, G__24514);
        }
      };
      return obj24513;
    }()), helix.core.get_react().createElement("div", null, entries, " entries"))));
  };

  if (goog.DEBUG === true) {
    var G__24515 = G__24479;
    G__24515.displayName = "com.wsscode.blog.alternative-to-clj-js/ReadsCompareSequence";
    return G__24515;
  } else {
    return G__24479;
  }
}();

goog.exportSymbol('com.wsscode.blog.alternative_to_clj_js.ReadsCompareSequence', com.wsscode.blog.alternative_to_clj_js.ReadsCompareSequence);
Object.defineProperty(module.exports, "gen_map_sized", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.gen_map_sized;
  }
});
Object.defineProperty(module.exports, "bench_reads", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.bench_reads;
  }
});
Object.defineProperty(module.exports, "ReadsCompareProgressive", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.ReadsCompareProgressive;
  }
});
Object.defineProperty(module.exports, "bench_spread", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.bench_spread;
  }
});
Object.defineProperty(module.exports, "SpreadObjectBenchmark", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.SpreadObjectBenchmark;
  }
});
Object.defineProperty(module.exports, "bench_seq_reads", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.bench_seq_reads;
  }
});
Object.defineProperty(module.exports, "ReadsCompareSequence", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.alternative_to_clj_js.ReadsCompareSequence;
  }
});